import { Component, OnInit, ViewChild } from '@angular/core';
import { MatPaginator, PageEvent } from '@angular/material';
import { ActivatedRoute, Router } from '@angular/router';
import swal from 'sweetalert2';
import { CondicaoDePagamento } from '../models/condicao-de-pagamento';
import { Filtro } from '../models/filtro';
import { CarregandoService } from '../services/carregando.service';
import { CondicaoDePagamentoService } from '../services/condicao-de-pagamento.service';
import { NotificacaoService } from '../services/notificacao.service';
import { UtilitarioService } from '../services/utilitario.service';
import { PaginatorService } from '../services/paginator.service';

@Component({
  selector: 'app-condicao-de-pagamento',
  templateUrl: './condicao-de-pagamento.component.html',
  styleUrls: ['./condicao-de-pagamento.component.scss']
})
export class CondicaoDePagamentoComponent implements OnInit {

  // variáveis
  condicoesDePagamento: CondicaoDePagamento[] = [];
  condicoesDePagamentoFiltrados: CondicaoDePagamento[] = [];
  carregando = true;
  campoOrdenacao = 'nome';
  ordenarDesc = false;
  editavel = true;
  paginacao;
  listaDeItensPorPagina;
  itensPorPagina;
  filtroNome: Filtro = { Propriedade: 'nome', Valor: '' };
  filtros: Filtro[] = [this.filtroNome];
  status = [{ id: 0, nome: 'Bloqueado' }, { id: 1, nome: 'Ativo' }];
  statusSelecionado = 1;

  @ViewChild('paginator', { static: false }) paginator: MatPaginator;

  // construtor
  constructor(private condicaoDePagamentoService: CondicaoDePagamentoService,
              private utilitarioService: UtilitarioService,
              private router: Router,
              private paginatorService: PaginatorService,
              private carregandoService: CarregandoService,
              private notificacaoService: NotificacaoService,
              private route: ActivatedRoute) {

  }

  ngOnInit() {
    const pagination = this.paginatorService.consultarPaginacao();

    this.paginacao = pagination.paginacao;
    this.itensPorPagina = pagination.itensPorPagina;
    this.listaDeItensPorPagina = pagination.listaDeItensPorPagina;

    this.buscarCondicoesDePagamento();
  }

  ordena(campo) {
    if (campo) {
      this.campoOrdenacao = campo;
      this.ordenarDesc = !this.ordenarDesc;

      this.condicoesDePagamento = this.condicoesDePagamento.sort((a, b) => {
        const isAsc = !this.ordenarDesc;
        switch (this.campoOrdenacao) {
        case 'nome': return this.compare(a.descricao, b.descricao, isAsc);
        default: return 0;
        }
      });

      this.mudaDePagina({ length: this.paginator.length, pageIndex: this.paginator.pageIndex, pageSize: this.paginator.pageSize });
    }

    return false;
  }

  compare(a: number | string, b: number | string, isAsc: boolean) {
    if (typeof a === 'string') {
      a = a.toLowerCase();
    }

    if (typeof b === 'string') {
      b = b.toLowerCase();
    }

    return (a < b ? -1 : 1) * (isAsc ? 1 : -1);
  }

  filtra() {
    this.condicoesDePagamentoFiltrados = this.condicoesDePagamento.filter(p => p.descricao.toLowerCase().
      includes(this.filtroNome.Valor.toString().toLowerCase()));

    if (this.itensPorPagina > this.listaDeItensPorPagina[this.listaDeItensPorPagina.length - 1]) {
      this.itensPorPagina = 10;
    }

    this.paginacao.total = this.condicoesDePagamentoFiltrados.length;
    this.paginator.firstPage();
    this.mudaDePagina({ length: this.condicoesDePagamento.length, pageIndex: 0, pageSize: this.itensPorPagina });
  }

  buscarCondicoesDePagamento() {
    this.carregandoService.mostra('buscaCondicoesDePagamento');
    this.carregando = true;

    this.condicaoDePagamentoService.consultar(this.statusSelecionado).subscribe((data: any) => {
      this.paginator.firstPage();
      this.condicoesDePagamento = data;
      this.listaDeItensPorPagina = this.utilitarioService.calculaItensPorPagina(this.condicoesDePagamento.length);

      if (this.itensPorPagina > this.listaDeItensPorPagina[this.listaDeItensPorPagina.length - 1]) {
        this.itensPorPagina = 10;
      }

      this.paginacao.total = this.condicoesDePagamento.length;
      this.mudaDePagina({ length: this.condicoesDePagamento.length, pageIndex: 0, pageSize: this.itensPorPagina });
      this.carregando = false;
      this.carregandoService.esconde('buscaCondicoesDePagamento');

    }, (erro) => {
      this.carregandoService.esconde('buscaCondicoesDePagamento');
      this.notificacaoService.erro(erro);
    });
  }

  novoCondicaoDePagamento() {
    this.router.navigate(['novo'], { relativeTo: this.route });
  }

  editarCondicaoDePagamento(condicaoDePagamento: CondicaoDePagamento) {
    this.router.navigate(['editar', condicaoDePagamento.idCondPag], { relativeTo: this.route });
  }

  bloquearCondicaoDePagamento(condicaoDePagamento: CondicaoDePagamento) {
    swal({
      title: 'Atenção!!',
      text: 'Deseja realmente bloquear a Condição de Pagamento?',
      type: 'warning',
      showCancelButton: true,
      confirmButtonClass: 'btn btn-info',
      cancelButtonClass: 'btn btn-danger',
      confirmButtonText: 'Sim',
      cancelButtonText: 'Não',
      buttonsStyling: false
    }).then((result) => {
      if (result.value) {
        this.carregandoService.mostra('bloquearCondicaoDePagamento');
        this.condicaoDePagamentoService.bloquear(condicaoDePagamento.idCondPag).subscribe(resp => {

          this.notificacaoService.sucesso('Condição de Pagamento bloqueada com sucesso!!!');
          this.carregandoService.esconde('bloquearCondicaoDePagamento');
          this.buscarCondicoesDePagamento();
        }, (erro) => {
          this.carregandoService.esconde('bloquearCondicaoDePagamento');
          this.notificacaoService.erro(erro);
        });
      }
    });
  }

  mudaDePagina(pageEvent: PageEvent) {
    if (this.itensPorPagina !== pageEvent.pageSize)
      this.paginatorService.salvaPaginacao(pageEvent.pageSize);

    this.itensPorPagina = pageEvent.pageSize;
    this.paginacao.paginaAtual = pageEvent.pageIndex + 1;

    this.condicoesDePagamentoFiltrados = this.condicoesDePagamento.filter(p => p.descricao.toLowerCase().
      includes(this.filtroNome.Valor.toString().toLowerCase())).
      slice(pageEvent.pageIndex * pageEvent.pageSize,
        (pageEvent.pageIndex * pageEvent.pageSize) + pageEvent.pageSize);
  }
}
